<template>
  <v-layout justify-center>
    <v-flex>
      <v-card ref="form">
        <v-card-text>
          <template v-for="(error, index) in errors">
            <v-alert color="error" :value= "hasError('non_field_errors')">
              {{getErrorArray('non_field_errors')}}
            </v-alert>
          </template>
          <v-autocomplete
            :error="hasError('status')"
            :error-messages="getError('status')"
            :items="selectors.status"
            item-text="text"
            item-value="value"
            label="Статус"
            placeholder="Статус"
            v-model="value.status"
            no-data-text ="Нет данных"
          ></v-autocomplete>

          <v-text-field
            :error="hasError('motivation')"
            :error-messages="getError('motivation')"
            label="Описание причины изменения"
            v-model="value.motivation"
          ></v-text-field>
          <v-btn @click="update" color="primary">Сохранить</v-btn>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import urls from "../urls"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import {makeManagerUrl,makePostRequest} from "../../../helper";


    export default {
      name: "ChangeStatus",
      mixins: [UserDataFormMixin],
      props: {
        id: Number, typeSt: String,
      },
      data() {
        return {
          URL_CREATE: (urls.getUrl('admin|petition|petition|status-list', 'great')),
          URL_UPDATE: (urls.getUrl('admin|petition|petition|status-detail', 'update')),

          selectors: {
            status: [],
          },

          value: {
            id: this.id || undefined,
            status: this.status || [],
            motivation: this.motivation || undefined,
          },

        }
      },
      watch: {

        id: {
          handler(value) {
            // console.log(value)
            //изменения из листа
            if(this.$props.id!==undefined){
              this.getChoices(
                makeManagerUrl(urls.getUrl('selectors|petition|status-next', 'get').replace('<prev>', this.$props.id)),
              ).then(choices => {
                this.selectors.status = choices
              });
            }
          },
          // deep: true,
          // immediate: true,
        },
      },


      methods: {
        update: function () {
          let url = urls.getUrl('admin|petition|petition|petition_create_council-change-status', 'change_status').replace('<id>', this.$route.params.id);
          if(this.$props.typeSt === "council"){
              url = urls.getUrl('admin|petition|petition|petition_create_permanent_council-change-status', 'change_status').replace('<id>', this.$route.params.id);
          }
          let status = true;
          let data = this.getData();
          makePostRequest(url, data,"PATCH")
            .then(resp => {
              if(resp.status < 300) {
                status = false;
              }
              return resp.json();
            })
            .then(json => {
              if (!status) {
                this.$emit('ended', json);
              }else{
                this.receiveErrors(json);
              }
            });
        },
      },
      created() {
        // console.log(this.$props)
      }
    }
</script>

<style scoped>

</style>
